import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { NotificacaoTO } from "src/app/data/schema/Notifications/NotificacaoTO";
import { NotificationPopupService } from "./services/notification-popup.service";

@Component({
    selector: "app-notification-popup",
    templateUrl: "./notification-popup.component.html",
    styleUrls: ["./notification-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class NotificationPopupComponent implements OnInit, AfterViewInit, OnDestroy {
    public show$: Observable<boolean>;
    public notificacoes: NotificacaoTO[];
    private notificacaoSubscription: Subscription;
    private isReady = false;
    private interval: NodeJS.Timeout;

    constructor(private notificationService: NotificationPopupService) {
        this.notificationService.getNotificationsAsync();
    }

    ngOnDestroy(): void {
        clearInterval(this.interval);
    }

    ngAfterViewInit(): void {
        this.isReady = true;
    }

    ngOnInit(): void {
        this.show$ = this.notificationService.getShow();
        this.notificacaoSubscription = this.notificationService.getNotifications().subscribe((nots) => {
            this.notificacoes = nots;

            // if (this.isReady) {
            //     this.notificacoes.forEach((not) => {
            //         this.players.find((p) => p.playerId == not.id)?.changeVideo([...not.content]);
            //     });
            // }
        });
    }

    close() {
        this.notificationService.setShow(false);
    }
}
